export default function getFirstName(oidcUser) {
	let fName = oidcUser.GlobalFirstName;

	return fName;
}
